<template>
  <div class="date-range">
    <div class="inputs">
      <ui-field-input
        :id="`${id}-from`"
        label-position="inline"
        label="From"
        type="date"
        :value="from"
        :disabled="disabled"
        @input="setFrom"
      />
      <ui-field-input
        :id="`${id}-to`"
        label-position="inline"
        label="To"
        type="date"
        :value="to"
        :disabled="disabled"
        @input="setTo"
      />
    </div>
    <div class="predefined-options">
      <ui-button
        v-for="option in quickOptions"
        size="sm"
        :key="option.label"
        :pressed="isActiveOption(option)"
        :disabled="disabled"
        @click="setValue({ from: option.from, to: option.to })"
      >
        {{ option.label }}
      </ui-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: { type: String, required: true },
    value: Object,
    disabled: Boolean
  },
  computed: {
    from() {
      return this.value?.from;
    },
    to() {
      return this.value?.to;
    },
    todayValue() {
      return this.dateToValue(new Date());
    },
    yesterdayValue() {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      return this.dateToValue(date);
    },
    before7DaysValue() {
      const date = new Date();
      date.setDate(date.getDate() - 7);
      return this.dateToValue(date);
    },
    before30DaysValue() {
      const date = new Date();
      date.setDate(date.getDate() - 30);
      return this.dateToValue(date);
    },
    currentMonthStartValue() {
      const date = new Date();
      date.setDate(1);
      return this.dateToValue(date);
    },
    currentMonthEndValue() {
      const date = new Date();
      date.setDate(1); // to avoid month day difference issues
      date.setMonth(date.getMonth() + 1);
      date.setDate(0);
      return this.dateToValue(date);
    },
    lastMonthStartValue() {
      const date = new Date();
      date.setDate(0);
      date.setDate(1);
      return this.dateToValue(date);
    },
    lastMonthEndValue() {
      const date = new Date();
      date.setDate(0);
      return this.dateToValue(date);
    },
    quickOptions() {
      return [
        { label: "Today", from: this.todayValue, to: this.todayValue },
        {
          label: "Yesterday",
          from: this.yesterdayValue,
          to: this.yesterdayValue
        },
        {
          label: "Last 7 days",
          from: this.before7DaysValue,
          to: this.todayValue
        },
        {
          label: "Last 30 days",
          from: this.before30DaysValue,
          to: this.todayValue
        },
        {
          label: "This month",
          from: this.currentMonthStartValue,
          to: this.currentMonthEndValue
        },
        {
          label: "Last month",
          from: this.lastMonthStartValue,
          to: this.lastMonthEndValue
        }
      ];
    }
  },
  methods: {
    isActiveOption({ from, to }) {
      return from === this.from && to === this.to;
    },
    dateToValue(date) {
      return [
        date.getFullYear(),
        (date.getMonth() + 1).toString().padStart(2, "0"),
        date.getDate().toString().padStart(2, "0")
      ].join("-");
    },
    setValue(value) {
      this.$emit("input", value);
    },
    setFrom(value) {
      let { to } = this.value;
      if (to < value) to = value;
      this.$emit("input", { from: value, to });
    },
    setTo(value) {
      let { from } = this.value;
      if (from > value) from = value;
      this.$emit("input", { from, to: value });
    }
  }
};
</script>

<style scoped lang="scss">
.inputs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 0.5rem;
}
.predefined-options {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  row-gap: 0.5rem;
  column-gap: 0.5rem;
}
</style>
